var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('li',{staticClass:"bc-project-offers-list-item"},[_c(_setup.BCXAvatar,{attrs:{"size":26,"user-id":_vm.offer.creator.userId}}),_c('span',{staticClass:"c-name bcx-truncated-text"},[_vm._v(" "+_vm._s(_setup.displayName)+" ")]),_c('span',{staticClass:"c-date"},[_vm._v(" "+_vm._s(_setup.date)+" ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }